import React from 'react';
import QRCode from 'react-qr-code';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { PreviewCard, Button, Icon } from '@weezevent/nacre';

import Style from './qr-code.module.css';

export default function QRCodePreview({ color, locale, origin, baseUrl, pageType }) {
    const { t } = useTranslation();

    const finalUrl = React.useMemo(() => {
        let url = '';
        try {
            url = new URL(baseUrl);
        } catch {
            return url;
        }
        const urlParams = new URLSearchParams(url.searchParams);
        pageType === 'widget' && urlParams.set('color_primary', color.replace('#', ''));
        urlParams.set('locale', locale);
        urlParams.set('o', origin);
        return `${url.toString().split('?')[0]}?${decodeURIComponent(urlParams.toString())}`;
    }, [color, locale, origin, baseUrl]);

    const canDownload = React.useMemo(() => finalUrl?.length > 0, [finalUrl]);

    const onDownload = React.useCallback(() => {
        if (!canDownload) return;
        const svg = document.getElementById('QRCode');
        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.onload = () => {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            const pngFile = canvas.toDataURL('image/png');
            const downloadLink = document.createElement('a');
            downloadLink.download = 'QRCode';
            downloadLink.href = `${pngFile}`;
            downloadLink.click();
        };
        img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
    }, [canDownload]);

    return (
        <PreviewCard title={t('ticket.qrcode.previewTitle')}>
            <div className={Style['preview-qr-code']}>
                <div className={Style['qr-code']}>{canDownload && <QRCode id="QRCode" value={finalUrl} size={165} />}</div>
                <Button
                    fluid={true}
                    className={'wz-crop-panel__button'}
                    primary
                    disabled={!canDownload}
                    onClick={() => onDownload()}
                    label={
                        <>
                            <Icon name={'download'} />
                            {t('ticket.common.cta.download')}
                        </>
                    }
                />
            </div>
        </PreviewCard>
    );
}

QRCodePreview.propTypes = {
    organization: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired
};
